import { PAYMENT_TERMS } from 'settings/constants/billing'

const { DUE_ON_RECEIPT } = PAYMENT_TERMS

export const isDueOnReceiptPaymentTerm = paymentTerm => paymentTerm === DUE_ON_RECEIPT
